import { defineMessages, useIntl } from 'react-intl';
import classNames from 'classnames';

import { CheckIcon, Link, LinkVariant } from '@jsmdg/yoshi';
import { type ReviewWidget } from '../../../shared/reviews';
import { trackReadMoreClicked } from '../ReviewsHighlight/ReviewsHighlight.tracking';
import { ReviewsStarsRating } from '../ReviewsStarsRating';
import styles from './HighlightedReview.module.scss';

const messages = defineMessages({
    readMore: {
        defaultMessage: 'Mehr lesen',
    },
    verifiedBuyer: {
        defaultMessage: 'Verifzierter Käufer',
    },
});
interface HighlightedReviewProps {
    readonly review: ReviewWidget;
    readonly openReviewLink: () => void;
}

const HighlightedReview = ({ openReviewLink, review }: HighlightedReviewProps): JSX.Element => {
    const intl = useIntl();
    const formattedDate = intl
        .formatDate(new Date(review.createdAt), {
            day: '2-digit',
            month: '2-digit',
            year: '2-digit',
        })
        .replaceAll('.', '/');

    return (
        <div className={classNames(styles.tile, 'p-2-5x', 'd-grid')}>
            <div className={classNames(styles.top, 'd-inline-flex justify-content-between')}>
                <div>
                    <ReviewsStarsRating rating={review.score} />
                    <div className={styles.userName}>{review.userName}</div>
                    <div>
                        {review.verifiedBuyer && (
                            <div
                                className={classNames(
                                    styles.verifiedBuyer,
                                    styles.fontDefault,
                                    'align-items-center',
                                    'd-inline-flex',
                                )}
                            >
                                <CheckIcon size={24} className={styles.icon} />
                                {intl.formatMessage(messages.verifiedBuyer)}
                            </div>
                        )}
                    </div>
                </div>
                <div className={styles.formattedDateText}>{formattedDate}</div>
            </div>

            <div>
                <div className={styles.contentsContainer}>
                    <div className={styles.contents}>{review.content}</div>
                </div>
                <div className={styles.titleContainer}>
                    <Link
                        onClick={() => {
                            openReviewLink();
                            trackReadMoreClicked();
                        }}
                        variant={LinkVariant.Brand}
                    >
                        {intl.formatMessage(messages.readMore)}
                    </Link>
                </div>
            </div>
        </div>
    );
};

export { HighlightedReview };
